"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Error = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = require("./style");
var _diamond = require("../../assets/diamond.svg");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Error = function Error(_ref) {
  var error = _ref.error;
  if (!error) return null;
  return /*#__PURE__*/_react.default.createElement(_style.MessageWrapper, null, /*#__PURE__*/_react.default.createElement(_style.FormErrorMessage, null, /*#__PURE__*/_react.default.createElement("div", {
    className: error ? "img-container active" : "img-container"
  }, /*#__PURE__*/_react.default.createElement(_diamond.ReactComponent, null)), error));
};
exports.Error = Error;
var _default = Error;
exports.default = _default;